<nz-card class="card-simple" [nzTitle]="'integration.econ-01.response.referral' | translate" [nzExtra]="referralNumber">
  <ng-template #referralNumber>
    <ng-container *ngIf="!referral.dlReferralDeleted">
      <a (click)="openDocument(dlReferral)">{{ referral.identifier.value }}</a>
    </ng-container>
    <ng-container *ngIf="referral.dlReferralDeleted">
      {{ referral.identifier.value }}
      <span nz-text [nzType]="'danger'">({{ referral.status?.names | localName }})</span>
    </ng-container>
  </ng-template>
  <div nz-col>
    <hw-column-item label="integration.econ-01.data.referrer">
      <div>{{ referral.requester.practitioner.display }} ({{ referral.requester.practitioner.identifier.value }})</div>
      <div>{{ referral.requester.organization.display }} ({{ referral.requester.organization.identifier.value }})</div>
    </hw-column-item>
    <hw-column-item
      *ngIf="referral.performer.practitioner?.speciality?.code" label="integration.econ-01.response.performer"
    >
      {{ referral.performer.practitioner.display }} ({{ referral.performer.practitioner.speciality.code }})
    </hw-column-item>
    <hw-column-item
      *ngIf="referral.content.performerSpeciality?.code" label="integration.econ-01.response.referredSpeciality"
    >
      {{ referral.content.performerSpeciality?.code }}
      {{ referral.content.performerSpeciality?.code | localizedConceptName : 'speciality' | async }}
    </hw-column-item>
    <hw-column-item
      *ngIf="referral.performer?.consultationService?.code"
      label="integration.econ-01.response.referred-consultation-service"
    >
      {{ referral.performer?.consultationService?.code | localizedConceptName : 'consultation-service' | async }}
    </hw-column-item>
    <hw-column-item label="integration.econ-01.response.referral-reason">
      {{ referral.purpose }}
    </hw-column-item>
  </div>
  <nz-divider [nzText]="'integration.econ-01.response.diagnosis' | translate" nzOrientation="left"></nz-divider>
  <div nz-col>
    <hw-column-item *ngIf="referral.diagnosis">
      {{ referral.diagnosis.code }} - {{ referral.diagnosis.names | localName }}
    </hw-column-item>
    <hw-column-item *ngIf="referral.diagnosisInfo?.recurrence">
      {{ referral.diagnosisInfo.recurrence.code | localizedConceptName : 'condition-recurrence' | async }}
    </hw-column-item>
    <hw-column-item *ngIf="referral.diagnosisInfo?.text">
      {{ referral.diagnosisInfo.text }}
    </hw-column-item>
  </div>
  <nz-divider [nzText]="'integration.econ-01.response.anamnesis' | translate" nzOrientation="left"></nz-divider>
  <div nz-col>
    <hw-column-item>
      <div style="white-space: pre-wrap">{{ referral.content.anamnesis }}</div>
    </hw-column-item>
  </div>
</nz-card>
